import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { selectSession } from '../model/selectors';
import { AdvisorDashboard, useNavigateToPage } from '..';
import { SessionType } from '@shared';

export function useHomeNavigation() {
  const session = useSelector(selectSession);
  const navigateToPage = useNavigateToPage();
  const { isAuthenticated, isLoading } = useAuth0();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if ((!isAuthenticated || isLoading) && window.location.pathname !== '/') {
      return;
    }
    
    // Check if there's a redirect_to parameter in the URL
    const searchParams = new URLSearchParams(location.search);
    const redirectTo = searchParams.get('redirect_to');
    
    if (redirectTo && isAuthenticated) {
      // Navigate to the redirect_to URL and clear the search params
      navigate(redirectTo, { replace: true });
      return;
    }
    
    // navigate to home if authenticated and at root
    if (session.sessionType === SessionType.client && isAuthenticated) {
      navigate('/client/home', { replace: true });
      return;
    }

    // Handle advisor users
    if (session?.advisor?.advisorId) {
      const advisorId = session.advisor.advisorId;
      navigateToPage(AdvisorDashboard, { advisorId });
      return;
    }
  }, [
    session.sessionType,
    session.advisor,
    session.auth0Session,
    isAuthenticated,
    isLoading,
    navigate,
    navigateToPage,
    location.search,
  ]);
}
